var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"o-content-auto-center u-px-8 u-w-full"},[_c('div',{ref:"cookieScriptTag",staticClass:"u-w-full md:u-w-8/12 lg:u-w-6/12 u-mx-auto u-px-6 md:u-px-0 body-copy",attrs:{"id":"CookiePolicy"}})]),_c('div',{attrs:{"id":"cicc-template"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }